
import { Injectable, OnDestroy } from '@angular/core';

import { tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';

import { MonitorConfigService } from './monitor-config.service';
import { FileDownloadsApi } from '@api/fileDownloads/file-downloads.api';


@Injectable()
export class FileDownloadService implements OnDestroy {
    private unsavedMentionExportLimit$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    private unsavedMentionQuotaUsage$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    remainingUnsavedMentionQuota: number = 0;
    private remainingUnsavedMentionQuota$: BehaviorSubject<number> = new BehaviorSubject<number>(this.remainingUnsavedMentionQuota);

    private subscriptions: Subscription[] = [];

    constructor(
        public monitorConfigService: MonitorConfigService,
        public fileDownloadsApi: FileDownloadsApi,
    ) {
        this.subscriptions.push(
            combineLatest({
                limit: this.monitorConfigService.getUnsavedMentionExportLimit(),
                quotaUsage: this.fileDownloadsApi.getUnsavedMentionQuotaUsage()
            }).pipe(
                tap(({limit, quotaUsage}) => {
                    this.unsavedMentionExportLimit$.next(limit);
                    this.unsavedMentionQuotaUsage$.next(quotaUsage);
                    this.calculateUnsavedQuota(limit, quotaUsage);
                })
            ).subscribe()
        );
    }

    public getUnsavedMentionExportLimit(): Observable<number> {
        return this.unsavedMentionExportLimit$;
    }

    public getUnsavedMentionQuotaUsage(): Observable<number> {
        return this.unsavedMentionQuotaUsage$;
    }

    public getRemainingUnsavedMentionQuota(): Observable<number> {
        return this.remainingUnsavedMentionQuota$;
    }

    calculateUnsavedQuota(unsavedMentionExportLimit, unsavedMentionQuotaUsage) {
        if (unsavedMentionExportLimit === -1) {
            this.remainingUnsavedMentionQuota = -1;
        } else {
            this.remainingUnsavedMentionQuota = Math.max(unsavedMentionExportLimit - unsavedMentionQuotaUsage, 0);
        }
        this.remainingUnsavedMentionQuota$.next(this.remainingUnsavedMentionQuota);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
